import { useLocation, useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { useEffect, useState } from 'react';
import Data from "../backend/blogdata.json";

const BlogPage = () => {
    window.scrollTo(0, 0);
    const location = useLocation();
    let {key} = useParams();
    let title = Data[key].title
    let date = Data[key].date
    let content = Data[key].content
    let imagepath = Data[key].imgpath
    console.log(content);

    const [markdownContent, setMarkdownContent] = useState('');
    var filePath = content;
    useEffect(() => {
        fetch(filePath)
            .then((response) => response.text())
            .then((data) => setMarkdownContent(data))
            .catch((error) => console.error(error));
    }, []);
    // console.log(markdownContent);

    return (
        <div className="px-32 mt-24 mb-28 flex justify-between overflow-hidden lg:px-5">
            <div className="w-200 xl:w-full overflow-y-auto">
                <img src={imagepath} className="w-16 mb-5 hidden xl:block" />
                <h2 className="text-4xl font-bold pb-5">{title}</h2>
                <div className="markdown-container" style={{ height: "calc(100vh - 200px)", overflowY: "scroll" }}>
                    <ReactMarkdown className="prose dark:text-white">{markdownContent}</ReactMarkdown>
                </div>
            </div>

            <div className="flex flex-col items-center w-80 overflow-hidden xl:hidden">
                <img src={imagepath} className="w-40" />

                <div className="mt-10 bg-warmGray-100 p-5 rounded-md dark:text-black">
                    <div className="flex flex-col items-center">
                        <img src="./image/myPhoto.JPG" className="h-40 rounded-full" />
                        <p className="mt-5">
                            Hello and thanks for visiting! My name is Peter Johnson, and this is my website where I share
                            intersting blogs around technology and finance.
                        </p>
                    </div>
                    <div className="flex flex-col mt-5">
                        <p className="font-bold uppercase">Post Details</p>
                        <p className="mt-2"><span className="font-extrabold"> - </span> Published on {date}</p>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default BlogPage;